interface ServiceLevelPreset {
    firmwareUpdates: boolean;
    customerPortal: boolean;
    monitoringManagedServices: boolean;
    advancedMonitoring: boolean;
    api: boolean;
    managedServices: boolean;
    onsiteFieldServices: boolean;
    m2mDevice: boolean;
    proofOfPlay: boolean;
    customerOwnedParts: boolean;
    eventManagement: boolean;
    demo: boolean;
    advancedWarrantyAlerts: boolean;
    warranty: string;
    technicalSupport: string;
    fruReplacements: string;
    nonFruReplacements: string;
}

export class ServiceLevelPresetClass {
    public serviceLevelPresets: Map<Mri.Contracts.ServiceLevel, ServiceLevelPreset> = new Map([
        [
            Mri.Contracts.ServiceLevel.Warranty,
            {
                warranty: '',
                technicalSupport: '',
                fruReplacements: '',
                nonFruReplacements: '',
                firmwareUpdates: false,
                customerPortal: false,
                monitoringManagedServices: false,
                advancedMonitoring: false,
                api: false,
                managedServices: false,
                onsiteFieldServices: false,
                m2mDevice: false,
                proofOfPlay: false,
                customerOwnedParts: false,
                eventManagement: false,
                demo: false,
                advancedWarrantyAlerts: false,
            },
        ],
        [
            Mri.Contracts.ServiceLevel.SmartVuDepot,
            {
                warranty: '',
                technicalSupport: '',
                fruReplacements: '',
                nonFruReplacements: '',
                firmwareUpdates: false,
                customerPortal: false,
                monitoringManagedServices: false,
                advancedMonitoring: false,
                api: false,
                managedServices: false,
                onsiteFieldServices: false,
                m2mDevice: false,
                proofOfPlay: false,
                customerOwnedParts: false,
                eventManagement: false,
                demo: false,
                advancedWarrantyAlerts: false,
            },
        ],
        [
            Mri.Contracts.ServiceLevel.SmartVuAdvanced,
            {
                warranty: '',
                technicalSupport: '',
                fruReplacements: '',
                nonFruReplacements: '',
                firmwareUpdates: false,
                customerPortal: false,
                monitoringManagedServices: false,
                advancedMonitoring: false,
                api: false,
                managedServices: false,
                onsiteFieldServices: false,
                m2mDevice: false,
                proofOfPlay: false,
                customerOwnedParts: false,
                eventManagement: false,
                demo: false,
                advancedWarrantyAlerts: false,
            },
        ],
        [
            Mri.Contracts.ServiceLevel.Demo,
            {
                warranty: '',
                technicalSupport: '',
                fruReplacements: '',
                nonFruReplacements: '',
                firmwareUpdates: false,
                customerPortal: false,
                monitoringManagedServices: false,
                advancedMonitoring: false,
                api: false,
                managedServices: false,
                onsiteFieldServices: false,
                m2mDevice: false,
                proofOfPlay: false,
                customerOwnedParts: false,
                eventManagement: false,
                demo: false,
                advancedWarrantyAlerts: false,
            },
        ],
        [
            Mri.Contracts.ServiceLevel.SmartVuCustom,
            {
                warranty: '',
                technicalSupport: '',
                fruReplacements: '',
                nonFruReplacements: '',
                firmwareUpdates: false,
                customerPortal: false,
                monitoringManagedServices: false,
                advancedMonitoring: false,
                api: false,
                managedServices: false,
                onsiteFieldServices: false,
                m2mDevice: false,
                proofOfPlay: false,
                customerOwnedParts: false,
                eventManagement: false,
                demo: false,
                advancedWarrantyAlerts: false,
            },
        ],
        [
            Mri.Contracts.ServiceLevel.SmartVuPortal,
            {
                warranty: '',
                technicalSupport: '',
                fruReplacements: '',
                nonFruReplacements: '',
                firmwareUpdates: false,
                customerPortal: false,
                monitoringManagedServices: false,
                advancedMonitoring: false,
                api: false,
                managedServices: false,
                onsiteFieldServices: false,
                m2mDevice: false,
                proofOfPlay: false,
                customerOwnedParts: false,
                eventManagement: false,
                demo: false,
                advancedWarrantyAlerts: false,
            },
        ],
        [
            Mri.Contracts.ServiceLevel.SmartVuGold,
            {
                warranty: 'Full coverage during SLA term',
                technicalSupport: '25 / 7 / 364',
                fruReplacements: '3-5 BD – Freight split',
                nonFruReplacements: '7-9 BD – Freight split',
                firmwareUpdates: true,
                customerPortal: true,
                monitoringManagedServices: true,
                advancedMonitoring: false,
                api: false,
                managedServices: false,
                onsiteFieldServices: false,
                m2mDevice: false,
                proofOfPlay: false,
                customerOwnedParts: false,
                eventManagement: false,
                demo: false,
                advancedWarrantyAlerts: true,
            },
        ],
        [
            Mri.Contracts.ServiceLevel.SmartVuPlatinum,
            {
                warranty: 'Full coverage during SLA term',
                technicalSupport: '24 / 7 / 364',
                fruReplacements: 'NBD – MRI pays freight both ways',
                nonFruReplacements: '7-9 BD – Freight split',
                firmwareUpdates: true,
                customerPortal: true,
                monitoringManagedServices: true,
                advancedMonitoring: false,
                api: false,
                managedServices: false,
                onsiteFieldServices: true,
                m2mDevice: false,
                proofOfPlay: false,
                customerOwnedParts: false,
                eventManagement: false,
                demo: false,
                advancedWarrantyAlerts: true,
            },
        ],
        [
            Mri.Contracts.ServiceLevel.OutOfWarranty,
            {
                warranty: '',
                technicalSupport: '',
                fruReplacements: '',
                nonFruReplacements: '',
                firmwareUpdates: false,
                customerPortal: false,
                monitoringManagedServices: false,
                advancedMonitoring: false,
                api: false,
                managedServices: false,
                onsiteFieldServices: false,
                m2mDevice: false,
                proofOfPlay: false,
                customerOwnedParts: false,
                eventManagement: false,
                demo: false,
                advancedWarrantyAlerts: false,
            },
        ],
        [
            Mri.Contracts.ServiceLevel.MRIStandardWarranty,
            {
                warranty: 'Full coverage during SLA term',
                technicalSupport: '9 / 5',
                fruReplacements: '3-5 BD – Freight split',
                nonFruReplacements: '7-9 BD – Freight split',
                firmwareUpdates: true,
                customerPortal: true,
                monitoringManagedServices: true,
                advancedMonitoring: false,
                api: false,
                managedServices: false,
                onsiteFieldServices: false,
                m2mDevice: false,
                proofOfPlay: false,
                customerOwnedParts: false,
                eventManagement: false,
                demo: false,
                advancedWarrantyAlerts: true,
            },
        ],
    ]);
}
